import React from 'react'

function WarningIcon() {
  return (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <path d="M12 3 2.75 20h18.5L12 3Z" />
      <path d="M12 9v5" />
      <path d="M12 17.25h.01" />
    </svg>
  )
}

function ErrorIcon() {
  return (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <circle cx="12" cy="12" r="9" />
      <path d="m9 9 6 6" />
      <path d="m15 9-6 6" />
    </svg>
  )
}

export default function BuilderAlert({
  tone = 'warning',
  title,
  children,
  actionLabel,
  onAction,
  actionDisabled = false,
  className = '',
  ...props
}) {
  const isError = tone === 'error'
  const classes = ['builder-alert', `builder-alert--${tone}`, className].filter(Boolean).join(' ')

  return (
    <div
      className={classes}
      role="alert"
      aria-live={isError ? 'assertive' : 'polite'}
      data-alert-tone={tone}
      {...props}
    >
      <span className="builder-alert__icon" aria-hidden="true">
        {isError ? <ErrorIcon /> : <WarningIcon />}
      </span>
      <div className="builder-alert__content">
        {title && <strong className="builder-alert__title">{title}</strong>}
        <div className="builder-alert__message">{children}</div>
      </div>
      {actionLabel && (
        <button
          type="button"
          className="builder-alert__action"
          disabled={actionDisabled}
          onClick={onAction}
        >
          {actionLabel}
        </button>
      )}
    </div>
  )
}
